(function($){
  $(document).ready(function(){
    var $overlay = $('.faq-popup-overlay');
    var $popup   = $('.faq-popup');

    function openPopup(){
      $overlay.addClass('visible').attr('aria-hidden','false');
      requestAnimationFrame(function(){
        $popup.addClass('active').attr('aria-hidden','false');
        setTimeout(function(){
          $popup.find('a, button, [tabindex]')
            .filter(':visible')
            .first()
            .focus();
        }, 260);
      });
    }

    function closePopup(){
      $popup.removeClass('active').attr('aria-hidden','true');
      $overlay.removeClass('visible').attr('aria-hidden','true');
      $('.track-order-btn').focus(); // return focus to trigger
    }

    // Open popup
    $('.track-order-btn').off('click').on('click', function(e){
      e.preventDefault();
      openPopup();
    });

    // Close popup via close button
    $('.faq-popup-close').off('click').on('click', function(e){
      e.preventDefault();
      closePopup();
    });

    // Close popup via overlay click
    $overlay.off('click').on('click', function(){
      closePopup();
    });

    // Close popup via Escape key
    $(document).on('keydown', function(e){
      if (e.key === "Escape") { closePopup(); }
    });
  });
})(jQuery);